import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface GenderRadioFieldProps {
    register: UseFormRegisterReturn;
    error?: string;
    value?: "male" | "female" | "" | null;
    disabled?: boolean;
    id?: string;
    maleId?: string;
    femaleId?: string;
    onChange?: (value: string) => void;
    isEditable?: boolean;
    onEditClick?: () => void;
}

/**
 * Reusable Gender radio button field component
 */
const GenderRadioField = ({
    register,
    value,
    error,
    id,
    maleId,
    femaleId,
    disabled = false,
    onChange,
    isEditable = false,
    onEditClick,
}: GenderRadioFieldProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // Call register's onChange first
        if (register.onChange) {
            register.onChange(e);
        }
        // Call custom onChange for validation triggering
        if (onChange) {
            onChange(e.target.value);
        }
    };

    // ========== Event Handlers ==========
    const handleEditClick = () => {
        if (onEditClick) {
            onEditClick();
        }
    };

    return (
        <div className="form-control">
            {isEditable ? (
                <div className="flex justify-between items-center">
                    <label className="label h-7" htmlFor={id}>
                        <span className="text-base-content">Gender</span>
                    </label>
                    <button onClick={handleEditClick} className="text-edit-link font-bold text-sm leading-5 hover:underline">
                        Edit
                    </button>
                </div>
            ) : (
                <label className="label h-7" htmlFor={maleId}>
                    <span className="text-base-content">Gender</span>
                </label>
            )}
            <div className={`${error ? "text-error" : ""} ${disabled ? "opacity-50" : ""}`}>
                <label className={`flex items-center gap-2 h-9 py-2 px-1 ${disabled ? "" : "cursor-pointer"}`}>
                    <input
                        type="radio"
                        {...register}
                        onChange={handleChange}
                        value="male"
                        className={`radio ${error ? "radio-error" : "radio-primary"}`}
                        id={maleId || `${register.name}-male`}
                        disabled={disabled}
                    />
                    <span className="text-base-content">Male</span>
                </label>

                <label className={`flex items-center gap-2 h-9 py-2 px-1 ${disabled ? "" : "cursor-pointer"}`}>
                    <input
                        type="radio"
                        {...register}
                        onChange={handleChange}
                        value="female"
                        className={`radio ${error ? "radio-error" : "radio-primary"}`}
                        id={femaleId || `${register.name}-female`}
                        disabled={disabled}
                    />
                    <span className="text-base-content">Female</span>
                </label>
            </div>
            {error && <p className="text-error text-xs mt-1">{error}</p>}
        </div>
    );
};

export default GenderRadioField;
